import TaiFrame from './components/TaiFrame';

window['TaiFrame'] = {
    init: function (opts) {
        new TaiFrame(opts);
    }
};